import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Footer } from '@/components/generals/footer'
import { Navbar } from '@/components/generals/navbar'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='relative flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-electric focus:px-5 focus:py-3 focus:text-sm focus:font-medium focus:text-white'
            >
                Skip to content
            </a>

            <Navbar />

            <main id='main' tabIndex={-1} className='flex-1 outline-none'>
                {children}
            </main>

            <Footer />
        </div>
    )
}
